export default "__VITE_ASSET__C1zClZs2__"